import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`

const Scale = styled.div`
  height: 10px;
  width: 450px;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 15px;
`

const LabelScale = styled(Scale)`
    width: 480px;
`

const Label = styled.span<{ position: 'left' | 'center' | 'right' }>`
  width: 45px;
  height: 40px;
  text-align: ${(props) => props.position};
`

const Tick = styled.div<{ isMajor: boolean }>`
  height: ${(props) => (props.isMajor ? '100%' : '60%')};
  width: 2px;
  background: #333333;
`

const TimeScale: React.FC = () => {
  const labels = [
    '24 hrs before',
    '18 hrs before',
    '12 hrs before',
    '6 hrs before',
    'Now',
  ]

  return (
    <Container>
      <LabelScale>
        {labels.map((label, index) => (
          <Label
            key={label}
            position={
              index === 0
                ? 'left'
                : index === labels.length -1
                  ? 'right'
                  : 'center'
            }
          >
            {label}
          </Label>
        ))}
      </LabelScale>
      <Scale>
        {[...Array(25)].map((_, index) => (
          <Tick key={index} isMajor={index % 6 === 0} />
        ))}
      </Scale>
    </Container>
  )
}

export default TimeScale
